export const TOOLTIPS = {
    PERMISSIONS: {
        RELEASE_BUNDLE:{
            BUNDLE_NAME_PATTERN: 'Simple wildcard patterns for Release Bundle names.\n' +
            'Ant-style path expressions are supported (*, **, ?).\n' +
            'For example: \'product_*\''
        }
    },
	CREATE_BUNDLE: {
        QUERY: {
	        ADDITIONAL_PROPERTIES: 'Properties to be added or updated on each queried artifact on the Edge Nodes.',
            PATH_MAPPINGS: 'Input and output regex mapping pairs that define the path where the queried artifact is located and where it should be placed.<br>Note: Regex group tokens is supported.',
	        SEARCH_PROPERTIES: 'Use \'Or\' to fetch Artifacts that has one of the properties.<br>' +
	        'Use \'And\' to fetch Artifacts configured with all properties.',
	        INCLUDED: 'Use \'Or\' to fetch Artifacts that comply with one of the patterns,<br>' +
	        'Use \'And\' to fetch Artifacts that comply with all of the patterns.',
            INCLUDED_PATH: 'Use \'Or\' to fetch Path that comply with one of the patterns,<br>' +
                'Use \'And\' to fetch Path that comply with all of the patterns.'
        }
    }
};



// WEBPACK FOOTER //
// ./modules/distribution/constants/tooltips.constants.js